import React, { useState } from "react";
import { Facebook, Instagram, Link2, Check, Share2, X } from "lucide-react";
import { useToast } from "../hooks/use-toast";

// X (Twitter) glyph as an inline SVG since lucide's brand icon is limited
function XIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644Z" />
    </svg>
  );
}

const SHARE_TITLE = "Discover & Develop the True Potential of your Child — MapMyKid";

export default function ShareBar() {
  const { toast } = useToast();
  const [copied, setCopied] = useState(false);

  const getUrl = () => (typeof window !== "undefined" ? window.location.href : "https://mapmykid.com");

  const openPopup = (url) => {
    window.open(url, "_blank", "noopener,noreferrer,width=620,height=680");
  };

  const shareX = () => {
    const u = encodeURIComponent(getUrl());
    const t = encodeURIComponent(SHARE_TITLE);
    openPopup(`https://twitter.com/intent/tweet?url=${u}&text=${t}`);
  };

  const shareFb = () => {
    const u = encodeURIComponent(getUrl());
    openPopup(`https://www.facebook.com/sharer/sharer.php?u=${u}`);
  };

  const copyLink = async (msg) => {
    const url = getUrl();
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        const ta = document.createElement("textarea");
        ta.value = url;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
      toast({ title: msg || "Link copied", description: url });
    } catch (e) {
      toast({ title: "Could not copy", description: "Please copy the URL from the address bar." });
    }
  };

  const shareInsta = () => {
    // Instagram has no public web share-a-link intent, so we copy the link.
    copyLink("Link copied for Instagram");
    openPopup("https://www.instagram.com/");
  };

  const items = [
    { key: "x", label: "Share on X", Icon: XIcon, hover: "hover:bg-black hover:border-black", onClick: shareX },
    { key: "fb", label: "Share on Facebook", Icon: Facebook, hover: "hover:bg-[#1877F2] hover:border-[#1877F2]", onClick: shareFb },
    { key: "ig", label: "Share on Instagram", Icon: Instagram, hover: "hover:bg-[#E1306C] hover:border-[#E1306C]", onClick: shareInsta },
    {
      key: "copy",
      label: copied ? "Copied!" : "Copy link",
      Icon: copied ? Check : Link2,
      hover: "hover:bg-violet-600 hover:border-violet-600",
      onClick: () => copyLink("Link copied"),
    },
  ];

  return (
    <div className="hidden lg:flex fixed left-4 top-1/2 -translate-y-1/2 z-40 flex-col items-center gap-3">
      <span className="mb-1 flex items-center gap-1.5 text-[13px] font-bold uppercase tracking-wider text-slate-400">
        <Share2 className="h-4 w-4" />
      </span>
      {items.map(({ key, label, Icon, hover, onClick }) => (
        <button
          key={key}
          onClick={onClick}
          aria-label={label}
          className={`group relative grid h-12 w-12 place-items-center rounded-full border border-violet-100 bg-white text-slate-600 shadow-md shadow-violet-100/60 transition-all duration-200 hover:text-white hover:-translate-y-0.5 hover:shadow-lg ${hover}`}
        >
          <Icon className="h-5 w-5" />
          <span className="pointer-events-none absolute left-14 whitespace-nowrap rounded-lg bg-slate-900 px-3 py-1.5 text-[14px] font-semibold text-white opacity-0 -translate-x-1 transition-all duration-200 group-hover:opacity-100 group-hover:translate-x-0">
            {label}
          </span>
        </button>
      ))}
    </div>
  );
}
